import { render, staticRenderFns } from "./balanceTop.vue?vue&type=template&id=0bf789df&scoped=true&"
import script from "./balanceTop.vue?vue&type=script&lang=js&"
export * from "./balanceTop.vue?vue&type=script&lang=js&"
import style0 from "./balanceTop.vue?vue&type=style&index=0&id=0bf789df&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf789df",
  null
  
)

export default component.exports